var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDescription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#5f6368",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M800-480 656.77-277.08q-12.54 17.54-31.58 27.31T584.62-240h-360q-26.85 0-45.74-18.88Q160-277.77 160-304.62v-350.76q0-26.85 18.88-45.74Q197.77-720 224.62-720h360q22.3 0 40.96 10.54 18.65 10.54 31.19 28.08L800-480Zm-48.77 0L623.08-660q-6.16-8.46-16.54-14.23-10.39-5.77-21.92-5.77h-360q-9.24 0-16.93 7.69-7.69 7.69-7.69 16.93v350.76q0 9.24 7.69 16.93 7.69 7.69 16.93 7.69h360q11.53 0 21.92-5.77 10.38-5.77 16.54-14.23l128.15-180ZM200-480v200-400 200Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescription);
export default __webpack_public_path__ + "static/media/description.eb3f35a9bf48f6d939932885bc73f60f.svg";
export { ForwardRef as ReactComponent };